import { Typography, Grid } from "@mui/material";

const NoPolls = () => {
  return (
    <>
      <Grid justifyContent="center" alignItems="center" sx={{ mt: "146px" }}>
        <Typography
          variant="h1"
          sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          sem enquetes por enquanto
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          selecione uma opção e cadastre uma enquete
        </Typography>
      </Grid>
    </>
  );
};

export default NoPolls;
